var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.39893H2.2H11.8",
    stroke: "#AAAAAA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99922 3.39902V2.19951C3.99922 1.88138 4.12565 1.57628 4.35069 1.35133C4.57573 1.12638 4.88096 1 5.19922 1H7.59921C7.91747 1 8.2227 1.12638 8.44774 1.35133C8.67279 1.57628 8.79921 1.88138 8.79921 2.19951V3.39902M10.5992 3.39902V11.7956C10.5992 12.1137 10.4728 12.4188 10.2477 12.6438C10.0227 12.8687 9.71747 12.9951 9.39921 12.9951H3.39922C3.08096 12.9951 2.77573 12.8687 2.55069 12.6438C2.32565 12.4188 2.19922 12.1137 2.19922 11.7956V3.39902H10.5992Z",
    stroke: "#AAAAAA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19922 6.39746V9.99609",
    stroke: "#AAAAAA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60156 6.39746V9.99609",
    stroke: "#AAAAAA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.89b696a6b1905784d93a9958e9364f20.svg";
export { ForwardRef as ReactComponent };